import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <a
          className="App-link"
          href="https://www.attikas.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          My Attikas ...
        </a>
      </header>
    </div>
  );
}

export default App;
